<div class="vr-wrap">
  <h3 class="vr-heading" *ngIf="heading">{{ heading }}</h3>

  <div class="value-rise" [style.--vr-thumb]="hueColor">
    <!-- Two controls, nothing more: pick the hue, then drive the dial. -->
    <div class="vr-controls">
      <div class="vr-row">
        <label class="vr-label" for="vr-hue-input">Hue</label>
        <input id="vr-hue-input" class="vr-slider vr-hue-slider" type="range"
               min="0" max="359" step="1" [value]="hue"
               (input)="onHue( $any( $event.target ).value )"
               aria-label="Hue">
      </div>
      <div class="vr-row">
        <label class="vr-label" for="vr-level-input">Dial</label>
        <input id="vr-level-input" class="vr-slider" type="range"
               min="0" max="100" step="1" [value]="level"
               (input)="onLevel( $any( $event.target ).value )"
               aria-label="Dial level">
        <span class="vr-level">{{ levelLabel }}%</span>
      </div>
    </div>

    <!-- Two result swatches on the same hue and dial. The color surface stays clean;
         the label and hex sit below it. -->
    <div class="vr-results">
      <div class="vr-result">
        <div class="vr-swatch" [style.background]="hsvHex"></div>
        <span class="vr-result-name">HSV · Value</span>
        <span class="vr-result-hex">{{ hsvHex }}</span>
      </div>
      <div class="vr-result">
        <div class="vr-swatch" [style.background]="hslHex"></div>
        <span class="vr-result-name">HSL · Lightness</span>
        <span class="vr-result-hex">{{ hslHex }}</span>
      </div>
    </div>
  </div>
</div>
